import { VIEWING_REQUEST_EVENTS } from '../../event_bus_modules/viewing_request';
import { initializeForm } from '../../utils/form';
import { validateEmail, validateMobileNumber, validateNotEmpty } from '../../utils/validators';

const viewingRequestModal = $('#viewing-request-modal');
const $loaderLayer = viewingRequestModal.find('.loader-layer');
const viewingRequestFormWrapper = viewingRequestModal.find(
  '.viewing-request-modal__form-wrapper'
);
const viewingRequestSuccessMessage = viewingRequestModal.find(
  '.viewing-request-modal__success-message'
);
const viewingRequestForm = $('#viewing-request-form');
const csrfToken = viewingRequestForm
  .find('input[name="csrfmiddlewaretoken"]')
  .val();
const entityId = $('#_entity-id').val();

$(() => {
  const viewingRequestFormInstance = initializeForm(viewingRequestForm, {
    preventDefault: true,
    validate: (values) => {
      const errors = {
        ...validateNotEmpty(values, ['name', 'email', 'phone']),
        ...validateEmail(values, ['email']),
        ...validateMobileNumber(values, ['phone']),
      };
      const hasErrors = !$.isEmptyObject(errors);
      viewingRequestForm
        .find('button[type="submit"]')
        .attr('disabled', hasErrors);

      return errors;
    },
    onSubmit: (values) => {
      EVENT_BUS.dispatch(
        VIEWING_REQUEST_EVENTS.REQUEST_PRIVATE_TREATY_VIEWING,
        {
          entityId,
          values,
          csrfToken,
        }
      );
    },
  });

  const showLoaderLayer = () => {
    $loaderLayer.addClass('loader-layer--active');
  };

  const hideLoaderLayer = () => {
    $loaderLayer.removeClass('loader-layer--active');
  };

  const resetForm = () => {
    viewingRequestForm
      .find("textarea, input:not([name='submit'], [type='hidden'])")
      .val('')
      .trigger('change');
    viewingRequestFormInstance.restart();
  };

  const onSuccessfulViewingRequest = () => {
    hideLoaderLayer();
    viewingRequestFormWrapper.hide();
    viewingRequestSuccessMessage.show();
    resetForm();
  };

  const onViewingRequestError = (error) => {
    console.log(error);
  };

  EVENT_BUS.on(
    VIEWING_REQUEST_EVENTS.REQUEST_PRIVATE_TREATY_VIEWING,
    showLoaderLayer
  );
  EVENT_BUS.on(
    VIEWING_REQUEST_EVENTS.PRIVATE_TREATY_VIEWING_REQUEST_SUCCESS,
    onSuccessfulViewingRequest
  );
  EVENT_BUS.on(
    VIEWING_REQUEST_EVENTS.PRIVATE_TREATY_VIEWING_REQUEST_ERROR,
    onViewingRequestError
  );
});
